import { HttpContextToken } from '@angular/common/http';

export const CUSTOMER_ID_STORAGE_KEY = 'kntCustomerId';
export const CUSTOMER_ID_HEADER_KEY = 'X-Customer-Id';
export const DISABLE_CUSTOMER_CONTEXT = new HttpContextToken(() => false);
